import React from "react";
import { Link } from "gatsby";
// import { ThemeToggler } from "gatsby-plugin-dark-mode";
import FooterSocialIcons from "./footer-social-icons";
import MoonSvg from "../assets/moon.svg";
import SunSvg from "../assets/sun.svg";

import RssSvg from "../assets/rss-symbol.svg";
import edprof from "../assets/images/ed.jpg";
import richtarr from "../assets/arrow-pointing-to-right.png";

const Layout = ({ location, title, children }) => {
  const rootPath = `${__PATH_PREFIX__}/`;
  const isRootPath = location.pathname === rootPath;
  let headerSiteText;
  let theme = "light";

  if (isRootPath) {
    headerSiteText = (
      <h1 className="main-heading">
        <Link to="/">{title}</Link>
      </h1>
    );
  } else {
    headerSiteText = (
      <Link className="header-link-home" to="/">
        {title}
      </Link>
    );
  }
  function toggleTheme(thm) {
    console.log("Theme toggle", thm);
  }

  return (
    <div className="global-wrapper" data-is-root-path={isRootPath}>
      <header className="global-header">
        <Link className="profile-brand__wrap" to="/aboutme/">
          <span className="profile-pic__wrap">
            <img src={edprof} alt="toggle theme" className="" />
          </span>
          <div className="about-lnk__wrap">
            <span>ABOUT&nbsp;ME</span>
            <img src={richtarr} alt="toggle theme" className="" />
          </div>
        </Link>

        <div className="header-actions">
          <div className="header-menu__wrap">
            <Link
              className="header-nav-link"
              activeClassName={"menu-active"}
              to="/"
            >
              Blog
            </Link>
            <Link
              className="header-nav-link"
              activeClassName={"menu-active"}
              to="/projects/"
            >
              Projects
            </Link>
            <Link
              className="header-nav-link"
              activeClassName={"menu-active"}
              to="/pages/contact/"
            >
              Contact
            </Link>
          </div>
          <div className="nav-menu-right">
            <button
              className="toggle-button header-nav-link"
              onClick={(e) => toggleTheme(theme === "light" ? "dark" : "light")}
            >
              <img
                src={theme === "dark" ? SunSvg : MoonSvg}
                alt="toggle theme"
                className="sun-moon"
              />
            </button>
            <button className="toggle-button header-nav-link">
              <img src={RssSvg} alt="toggle theme" className="rss-icon" />
            </button>
          </div>
        </div>
      </header>
      <main>{children}</main>
      <footer className="d-flex">
        <div className="copyright-text">
          Copyright © {new Date().getFullYear()},&nbsp;
          <a href="http://edrick.xyz">Edrick</a>
        </div>
        <div className="footer-icon-group">
          <FooterSocialIcons />
        </div>
      </footer>
    </div>
  );
};

export default Layout;
